<template>
  <div>
    <!-- Titulo -->
      <div
      style="position: absolute; top: -70px; left: 50%; transform: translateX(-50%); color: black; font-size: 17px; font-weight: bold;"
      >
      {{input.customized.name}}
    </div>

    <!-- Tanque -->
    <canvas
      @click="showTank = true"
      ref="tankCanvas"
      style="position: absolute; width: 100%; height: 80%; cursor: pointer"
    ></canvas>

    <!-- Canvas Etiqueta -->
    <canvas
      @click="showTank = true"
      ref="labelCanvas"
      :style="labelCanvasStyle"
    ></canvas>
  
    <!-- Bombas -->
    <canvas
      @click="showBomb = true"
      v-show="input.customized.bomba"
      ref="motorCanvas"
      width="100" 
      height="100" 
      style="position: absolute; width: 70px; height: 50px; top: 80%; left: 50%; transform: translateX(-50%);"
    ></canvas>

    <!-- Mostrar bombas -->
    <v-dialog v-if="!editing" v-model="showBomb" max-width="500">
      <v-card
        class="custom-card bomb-card"
        style="height: inherit"
      >
        <v-card-title
          class="d-flex flex-column align-start pt-2 pb-2"
          :style="{ backgroundColor: bombFailureAlarmValue ? `red` : `#e3eef9` }"
        >
          <div class="table-title">
            Bomba {{ input.customized.name }}
          </div>
        </v-card-title>

        <v-card-text class="mt-2 pt-1">
          <v-row>
            <v-col cols="4">
              <v-btn
                elevation="2"
                outlined
                block
                small
                style="background-color: #e3eef9"
                color="rgb(61, 59, 59)"
                @click="setRunOrderValue(true)"
              >
                MARCHA
              </v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn
                elevation="2"
                outlined
                block
                small
                style="background-color: #e3eef9"
                color="rgb(61, 59, 59)"
                @click="setRunOrderValue(false)"
              >
                PARO
              </v-btn>
            </v-col>
            <v-col cols="4">
              <div class="centered-div">
                <v-icon
                  class="mt-0"
                  medium
                  :color="continuousRunningValue ? `green` : `#7e827f`"
                  dark
                >
                  mdi-circle
                </v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Mostrar tanques -->
    <v-dialog v-if="!editing" v-model="showTank" max-width="500">
      <v-card
      class="custom-card agitator-card"
      style="height: inherit"
    >
      <v-card-title
        class="d-flex flex-column align-start pt-2 pb-2"
        :style="{ backgroundColor: !isLaboratory() && failureAlarmValue ? `red` : `#e3eef9` }"
      >
        <div class="table-title"> Tanque {{ input.customized.name }}</div>
      </v-card-title>

      <v-card-text
        class="mt-3"
        style="position: relative"
      >
        <v-row
          v-if="!isLaboratory()"
          style="margin-bottom: 40px"
        >
          <v-col cols="8">
            <MoveableComponent
              v-if="input.customized.run_order_configuration"
              :item="input.customized.run_order_configuration"
            >
              <component
                :is="input.customized.run_order_configuration.settings.component_type"
                :input="input.customized.run_order_configuration"
              >
              </component>
            </MoveableComponent>
            <MoveableComponent
              v-if="input.customized.discontinuous_order_configuration"
              :item="input.customized.discontinuous_order_configuration"
            >
              <component
                :is="input.customized.discontinuous_order_configuration.settings.component_type"
                :input="input.customized.discontinuous_order_configuration"
              >
              </component>
            </MoveableComponent>
            <MoveableComponent
              v-if="input.customized.stop_order_configuration"
              :item="input.customized.stop_order_configuration"
            >
              <component
                :is="input.customized.stop_order_configuration.settings.component_type"
                :input="input.customized.stop_order_configuration"
              >
              </component>
            </MoveableComponent>
            <MoveableComponent
              v-if="input.customized.continuous_order_configuration"
              :item="input.customized.continuous_order_configuration"
            >
              <component
                :is="input.customized.continuous_order_configuration.settings.component_type"
                :input="input.customized.continuous_order_configuration"
              >
              </component>
            </MoveableComponent>
          </v-col>
          <v-col
            cols="4"
            class="mt-3"
          >
            <div class="centered-div">
              <v-icon
                class="mt-0"
                medium
                :color="engineValue ? `green` : `#7e827f`"
                dark
              >
                mdi-circle
              </v-icon>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="6"
            @click="showVolumeHistoryDialog = true"
          >
            <div
              class="v-label mt-4 body-2"
              style="text-align: center"
            >
              Vol: {{ value > 1000 ? Math.round(value) : (value || 0).toFixed(2) }} L
            </div>
          </v-col>
          <v-col
            cols="6"
            @click="showTemperatureHistoryDialog = true"
          >
            <div
              class="v-label mt-4 mb-4 body-2"
              style="text-align: center"
            >
              Tmp: {{ temperatureValue > 1000 ? Math.round(temperatureValue) : (temperatureValue || 0).toFixed(2) }} ºC
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions v-if="!isLaboratory()">
        <v-spacer></v-spacer>
        <v-btn
          v-if="input.customized.variator_speed_configuration?.customized.address"
          icon
          @click="showVariatorSpeedDialog = true"
        >
          <v-icon>mdi-car-speed-limiter</v-icon>
        </v-btn>
        <v-btn
          v-if="!isProduction()"
          icon
          @click="showTimeConfigurationDialog = true"
        >
          <v-icon>mdi-timer-cog-outline</v-icon>
        </v-btn>
        <v-btn
          v-if="!isProduction()"
          icon
          @click="showVolumeCalibrationDialog = true"
        >
          <v-icon>mdi-arrow-expand-vertical</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
    <v-dialog
      v-model="showVariatorSpeedDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">Configurar velocidad del variador de Tanque {{ input.customized.name }}</div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-if="input.customized.variator_speed_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.variator_speed_configuration">
                  <component
                    :is="input.customized.variator_speed_configuration.settings.component_type"
                    :input="input.customized.variator_speed_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showVariatorSpeedDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showTimeConfigurationDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">
            Configurar tiempos de funcionamiento discontinuo Tanque {{ input.customized.name }}
          </div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col v-if="input.customized.running_time_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.running_time_configuration">
                  <component
                    :is="input.customized.running_time_configuration.settings.component_type"
                    :input="input.customized.running_time_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
            <v-col v-if="input.customized.stopped_time_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.stopped_time_configuration">
                  <component
                    :is="input.customized.stopped_time_configuration.settings.component_type"
                    :input="input.customized.stopped_time_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showTimeConfigurationDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="showVolumeCalibrationDialog"
      max-width="1000px"
    >
      <v-card class="custom-card">
        <v-card-title class="d-flex flex-column align-start">
          <div class="table-title">Calibrar volumen de Tanque {{ input.customized.name }}</div>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <div class="label-write">
                <p class="label-write-text">Volumen tara: 0</p>
              </div>
            </v-col>
            <v-col>
              <v-switch
                inset
                dense
                hide-details
                class="pt-4 mt-1"
                label="Tara"
                v-model="volumeTareOrder"
              ></v-switch>
            </v-col>

            <v-col>
              <div class="v-label pt-4 mt-2">Resultado: {{ volumeTareResult ? "CORRECTO" : "PENDIENTE" }}</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col v-if="input.customized.volume_calibration_configuration">
              <v-card-text>
                <MoveableComponent :item="input.customized.volume_calibration_configuration">
                  <component
                    :is="input.customized.volume_calibration_configuration.settings.component_type"
                    :input="input.customized.volume_calibration_configuration"
                  >
                  </component>
                </MoveableComponent>
              </v-card-text>
            </v-col>
            <v-col>
              <v-switch
                inset
                dense
                hide-details
                class="pt-4 mt-1"
                label="Calibración"
                v-model="volumeCalibrationOrder"
              ></v-switch>
            </v-col>

            <v-col>
              <div class="v-label pt-4 mt-2">Resultado: {{ volumeCalibrationResult ? "CORRECTO" : "PENDIENTE" }}</div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn @click="showVolumeCalibrationDialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import emptyTankWithoutShadeImageSrc from "@/plugins/tank_canvas/assets/empty_tank_without_shade.png";
import emptyTankWithShadeImageSrc from "@/plugins/tank_canvas/assets/empty_tank_with_shade.png";
import tankLiquidImageSrc from "@/plugins/tank_canvas/assets/tank_liquid.png";
import MotorApagadoImageSrc from "@/plugins/tank_canvas_quesos/assets/motorApagado.png";
import MotorEncendidoImageSrc from "@/plugins/tank_canvas_quesos/assets/motorEncendido.png";
import MoveableComponent from "@/components/generic/MoveableComponent.vue";
export default {
  name: "koiote-tank-canvas-quesos",

  props: {
    input: Object,
  },
  components: {
    MoveableComponent,
  },
  data() {
    return {
      emptyTankWithShadeImage: null,
      emptyTankWithoutShadeImage: null,
      tankLiquidImage: null,
      motorApagadoImage: null,
      motorEncendidoImage: null,
      showTank: false,
      showBomb: false,
      showVolumeCalibrationDialog: false,
      showTimeConfigurationDialog: false,
      showVariatorSpeedDialog: false,
      labelCanvasStyle: {
        position: "absolute",
        height: "40%",
        top: "10%",
        left: "20%",
        zIndex: 2,
        background: "rgba(255, 255, 255, 0.6)",
        border: "1px solid black",
        width: "0px",
        cursor: "pointer"
      }
    };
  },

  computed: {
    ...mapState(["editing"]),

    vartable() {
      return this.actualPage().global_item_list.find((gi) => gi.settings.component_type.includes("connection"))
        .customized.vartable;
    },
    allImagesLoaded() {
      return this.emptyTankWithShadeImage != null && this.emptyTankWithoutShadeImage != null && this.tankLiquidImage && this.motorApagadoImage != null && this.motorEncendidoImage != null;
    },

    //Tanques
    value() {
      try {
        return (
        this.vartable.find((v) => v.formatted_address == this.input.customized.volume_address)?.value || 0
      );
      } catch (error) {
        '?'
      }
    },
    temperatureValue() {
      try {
        return (
       
        this.vartable.find((v) => v.formatted_address == this.input.customized.temp_address)?.value || 0
      );
      } catch (error) {
        '?'
      }
    },
    volumeCalibrationResult() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_result)
        ?.value;
    },
    volumeTareResult() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_result)
        ?.value;
    },
    volumeTareOrder: {
      get() {
        return (
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_order)?.value ==
          true
        );
      },
      set(value) {
        const variableToChange =
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_tare_order) || {};
        variableToChange.value = value;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: variableToChange?.address,
            value: this.adaptFormat({ type: "BIT", value }),
          },
        });
      },
    },
    volumeCalibrationOrder: {
      get() {
        return (
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_order)
            ?.value == true
        );
      },
      set(value) {
        const variableToChange =
          this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_volume_calibration_order) ||
          {};
        variableToChange.value = value;
        this.doPublish({
          topic: this.write_topic,
          message: {
            address: variableToChange?.address,
            value: this.adaptFormat({ type: "BIT", value }),
          },
        });
      },
    },
    engineValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_engine)?.value;
    },
    failureAlarmValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_failure_alarm)?.value;
    },

    //Bombas
    bombFailureAlarmValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_bomb_failure_alarm)?.value;
    },
    continuousRunningValue() {
      return this.vartable?.find((v) => v.formatted_address == this.input.customized.variable_continuous_running)
        ?.value;
    },
  },

  methods: {
    ...mapGetters(["actualPage", "isProduction", "isLaboratory"]),

    // Tanques -------------------------------------------------------------
    async applyMask() {
      const canvas = this.$refs.tankCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      if (this.emptyTankWithoutShadeImage && this.tankLiquidImage && this.emptyTankWithShadeImage && canvas) {
        const newHeight = (this.value * canvas.height) / (this.input?.customized?.maximum_value || 100);

        const dy = canvas.height - newHeight;
        await ctx.drawImage(this.tankLiquidImage, 0, dy, canvas.width, newHeight);

        ctx.globalCompositeOperation = "destination-in";
        await ctx.drawImage(this.emptyTankWithoutShadeImage, 0, 0, canvas.width, canvas.height);

        ctx.globalCompositeOperation = "multiply";
        await ctx.drawImage(this.emptyTankWithShadeImage, 0, 0, canvas.width, canvas.height);
      }
      this.drawLabelCanvas();
    },
    drawLabelCanvas() {
      const canvas = this.$refs.labelCanvas;
      const ctx = canvas.getContext("2d");

      ctx.clearRect(0, 0, canvas.width, canvas.height); // Limpia el canvas

      // Dibuja el texto en el canvas de la etiqueta
      const volumeText = `${ this.value > 1000 ? Math.round(this.value) : (this.value || 0).toFixed(2) } L`;
      const tempText = `${ this.temperatureValue > 1000 ? Math.round(this.temperatureValue) : (this.temperatureValue || 0).toFixed(2) } ºC`
      ctx.fillStyle = "black";
      ctx.font = "40px Arial";
      ctx.fillText(volumeText, 85, 70);
      ctx.fillText(tempText, 85, 120); // Dibuja el texto en la posición deseada
    },

    loadEmptyTankWithShadeImage() {
      const img = new Image();
      img.src = emptyTankWithShadeImageSrc;
      img.onload = () => (this.emptyTankWithShadeImage = img);
    },

    loadEmptyTankWithoutShadeImage() {
      const img = new Image();
      img.src = emptyTankWithoutShadeImageSrc;
      img.onload = () => (this.emptyTankWithoutShadeImage = img);
    },

    loadTankLiquidImage() {
      const img = new Image();
      img.src = tankLiquidImageSrc;
      img.onload = () => (this.tankLiquidImage = img);
    },

    // Bombas ---------------------------------------------------------------------------
    async makeMotorBomba() {
      const canvas = this.$refs.motorCanvas;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      const img = this.continuousRunningValue ? this.motorEncendidoImage : this.motorApagadoImage;
      if(canvas && img) {
        await ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
      }
    },

    loadMotorApagadoImage() {
      const img = new Image();
      img.src = MotorApagadoImageSrc;
      img.onload = () => (this.motorApagadoImage = img);
    },

    loadMotorEncendidoImage() {
      const img = new Image();
      img.src = MotorEncendidoImageSrc;
      img.onload = () => (this.motorEncendidoImage = img);
    },

    setRunOrderValue(value) {
      const variableToChange = this.vartable.find(
        (v) => v.formatted_address == this.input.customized.variable_run_order
      );
      variableToChange.value = value;
      this.doPublish({
        topic: this.write_topic,
        message: {
          address: variableToChange.address,
          value: this.adaptFormat({ type: "BIT", value }),
        },
      });
    },

    adaptFormat(item) {
      return (() => {
        switch (item.type) {
          case "BIT":
            return item.value;
          case "ENTERO":
          case "REAL":
            return Number(item.value);
          default:
            return "";
        }
      })();
    },

    setCanvasWidth() {
      const tankCanvas = this.$refs.tankCanvas;
      if (tankCanvas) {
        console.log("Si que esta tankcanvas")
        const tankCanvasWidth = tankCanvas.offsetWidth * 0.63;
        this.labelCanvasStyle.width = `${tankCanvasWidth}px`;
      }else {
        console.log("no esta tankcanvas")
      }
    }
  },

  mounted() {
    this.loadMotorEncendidoImage();
    this.loadMotorApagadoImage()
    this.loadEmptyTankWithShadeImage();
    this.loadEmptyTankWithoutShadeImage();
    this.loadTankLiquidImage();
    this.setCanvasWidth();
    window.addEventListener("resize", this.setCanvasWidth);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.setCanvasWidth);
  },

  watch: {
    value() {
      this.applyMask();
    },

    continuousRunningValue() {
      this.makeMotorBomba();
    },

    allImagesLoaded(value) {
      if (value) {
        this.applyMask();
        this.makeMotorBomba();
      }
    },

    input: {
      handler() {
        this.applyMask();
        this.makeMotorBomba();
      },
      deep: true,
    },
  },
};
</script>
